import { useQuery, gql } from "@apollo/client";

const PATIENT_DISCOUNT_INCREMENTS_QUERY = gql`
  query PatientDiscountIncrements_Shared_Query {
    currentStore {
      id
      patientDiscountIncrements
    }
  }
`;

interface PatientDiscountIncrementsQueryData {
  currentStore: {
    id: string;
    patientDiscountIncrements: number[];
  };
}

const usePatientDiscountIncrementsQuery = () =>
  useQuery<PatientDiscountIncrementsQueryData>(PATIENT_DISCOUNT_INCREMENTS_QUERY);

export type { PatientDiscountIncrementsQueryData };
export { usePatientDiscountIncrementsQuery, PATIENT_DISCOUNT_INCREMENTS_QUERY };
